/*
 * Copyright © 2025. Legalbird eine Marke der Legalbird GmbH
 */

import { abstractLitigationCaseValidators } from "../AbstractLitigationCase/abstractLitigationCaseValidators";

export const generalCivilLawValidators = {
  ...abstractLitigationCaseValidators,
};
